<template>
    <a :href="'tel:'+phoneNumberDatas.number" class="PhoneNumber__container">
        <div class="PhoneNumber__content">
            <div>
                <img 
                    class="icon icon-phone"
                    :src="`${baseUrlMedia}/media/topheaderblock/${phoneNumberDatas.image}`" 
                    alt="icon phone" 
                />
            </div>
            <div class="block-text">
                <span class="phone-num" :inner-html.prop="phoneNumberDatas.number"></span>
                <span class="phone-info">Prix d'un appel local</span>
            </div>
        </div>   
    </a>
</template>

<script>

export default {
    name: 'PhoneNumber',

    props: {
        phoneNumberDatas: {
            type: Object,
            default: {},
        },
        
        baseUrlMedia: {
            type: String,
            required: false,
            default: process.env.VUE_APP_API_BASE_URL
        }
    }
    
}
</script>

<style lang="scss">
.PhoneNumber__container {
    display: none;
    align-self:center;

    @media ($mq-desktop) {
        display: block;
        margin: 0 2.5% 0 10px;
    }

    @media ($mq-large-desktop) {
        margin: 0 10px 0 20px;
    }

    @media (min-width: 1400px) {
        margin: 0 3% 0 20px;
    }

    .PhoneNumber__content{
        display: flex;
        height: 50px;
        padding: 5px 10px;
        border: 1px solid #ECECEC;
        border-radius: 25px;
        align-items: center;

        .icon-phone {
            display: inline-block;
            width: 35px;
            height: 35px;
        } 

        .block-text {
            padding: 0 15px;
            span{
                display: block;
            }
            .phone-num {
                font-weight: 700;
                line-height: 1.7rem;
                font-size: 1.7rem;
                margin-bottom: 2px;
                color: #24495F;              
            }
            .phone-info {
                color: #666666;
                font-size: 1.1rem;
                line-height: 1.2rem;
            }
            
        }
    }
}
</style>